import {
  parseDate
} from "./chunk-C3UEOT3Y.mjs";

// src/date/add.ts
var dateAdd = ({
  date,
  interval = "second",
  value
}) => {
  let originalDate = date;
  if (!(originalDate instanceof Date)) {
    originalDate = parseDate(originalDate);
  }
  if (!(originalDate == null ? void 0 : originalDate.getTime())) {
    return void 0;
  }
  const ret = new Date(originalDate);
  const checkRollover = function() {
    if (ret.getDate() != originalDate.getDate()) {
      ret.setDate(0);
    }
  };
  switch (String(interval).toLowerCase()) {
    case "year":
      ret.setFullYear(ret.getFullYear() + value);
      checkRollover();
      break;
    case "quarter":
      ret.setMonth(ret.getMonth() + 3 * value);
      checkRollover();
      break;
    case "month":
      ret.setMonth(ret.getMonth() + value);
      checkRollover();
      break;
    case "week":
      ret.setDate(ret.getDate() + 7 * value);
      break;
    case "day":
      ret.setDate(ret.getDate() + value);
      break;
    case "hour":
      ret.setTime(ret.getTime() + value * 36e5);
      break;
    case "minute":
      ret.setTime(ret.getTime() + value * 6e4);
      break;
    // Default is second
    default:
      ret.setTime(ret.getTime() + value * 1e3);
      break;
  }
  return ret;
};

export {
  dateAdd
};
//# sourceMappingURL=chunk-RWFVRZK3.mjs.map